<template>
  <div class="header">
    <div class="container-fluid">
      <!-- Hearer  -->
      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item fw-bolder">Role Template</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <!-- Card  -->
      <div class="card">
        <div class="card-header">
          <div class="col-12 col-lg-3">
            <v-select
              v-model="app_id"
              :options="listApp.data"
              :reduce="(e) => e"
              label="name"
              placeholder="Select Application"
              @input="getRoles(app_id.id)"
            >
              <span slot="no-options">Select Application</span>
            </v-select>
          </div>
          <div class="col-12 col-lg-3" v-if="app_id != ''">
            <v-select
              v-model="role_id"
              :options="listRoles"
              :reduce="(e) => e"
              label="name"
              placeholder="Select Role"
              @input="getCompany(app_id.id, role_id.id)"
            >
              <span slot="no-options">Select Role</span>
            </v-select>
          </div>
        </div>
        <div class="card-body mt-3 mb-3">
          <nav class="navbar-vertical mt-3 ml-5">
            <ul
              class="navbar-nav accordion"
              style="z-index: 99999999"
              role="tablist"
              v-if="role_id != ''"
            >
              <li class="nav-item" v-for="(company, i) in listCompany" :key="i">
                <div :class="`nav-link form-check form-check-inline`">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="company.isGranted"
                    @change="
                      changeCompany($event, company.id, company.company_name)
                    "
                  />
                  <a
                    @click="
                      getCompanyDepartement(company.id, app_id.id, role_id.id)
                    "
                    style="padding-left: 0"
                    tag="a"
                    :class="`nav-link mx-3  text-black fw-lighter`"
                    v-b-toggle="company.id"
                    data-navtype="parent"
                  >
                    Company {{ company.company_name }}
                  </a>
                </div>
                <b-collapse
                  v-if="listDepartement.length > 0"
                  :id="company.id"
                  :visible="listDepartement.length > 0"
                  accordion="my-accordion-3"
                  role="tabpanel"
                >
                  <ul
                    class="nav nav-sm flex-column accordion ml-4"
                    role="tablist"
                  >
                    <li
                      class="nav-item"
                      v-for="(depart, ids) in listDepartement"
                      :key="ids"
                    >
                      <div :class="`nav-link form-check form-check-inline`">
                        <input
                          v-model="depart.isGranted"
                          class="form-check-input"
                          type="checkbox"
                          @change="
                            changeBox(
                              $event,
                              company.id,
                              company.company_name,
                              depart.id,
                              depart.department_name,
                              'departement'
                            )
                          "
                        />
                        <a
                          @click="
                            getCompanyPosition(
                              depart.department_name,
                              company.id,
                              app_id.id,
                              role_id.id,
                              'pos1'
                            )
                          "
                          style="padding-left: 0"
                          tag="a"
                          :class="`nav-link mx-3  text-black fw-lighter`"
                          v-b-toggle="depart.id"
                          data-navtype="parent"
                        >
                          Departement {{ depart.department_name }}
                        </a>
                      </div>
                      <b-collapse
                        v-if="position1.length > 0"
                        :id="depart.id"
                        :visible="position1.length > 0"
                        accordion="my-accordion-4"
                        role="tabpanel"
                      >
                        <ul
                          class="nav nav-sm flex-column accordion ml-4"
                          role="tablist"
                        >
                          <li
                            class="nav-item"
                            v-for="(pos1, idx) in position1"
                            :key="idx"
                          >
                            <div
                              :class="`nav-link form-check form-check-inline`"
                              v-if="pos1.position_name == undefined"
                            >
                              <input
                                v-model="pos1.isGranted"
                                class="form-check-input"
                                type="checkbox"
                                @change="
                                  changeBox(
                                    $event,
                                    company.id,
                                    company.company_name,
                                    pos1.id,
                                    pos1.department_name,
                                    'departement'
                                  )
                                "
                              />
                              <a
                                @click="
                                  getCompanyPosition(
                                    pos1.department_name,
                                    company.id,
                                    app_id.id,
                                    role_id.id,
                                    'pos2'
                                  )
                                "
                                style="padding-left: 0"
                                tag="a"
                                :class="`nav-link mx-3  text-black fw-lighter`"
                                v-b-toggle="pos1.id"
                                data-navtype="parent"
                              >
                                Departement
                                {{ pos1.department_name }}
                              </a>
                            </div>
                            <div
                              v-else
                              :class="`nav-link form-check form-check-inline`"
                            >
                              <input
                                v-model="pos1.isGranted"
                                class="form-check-input"
                                type="checkbox"
                                @change="
                                  changeBox(
                                    $event,
                                    company.id,
                                    company.company_name,
                                    pos1.id,
                                    pos1.position_name,
                                    'position'
                                  )
                                "
                              />

                              <a
                                style="padding-left: 0"
                                tag="a"
                                :class="`nav-link text-black mx-3 collapsed  fw-lighter`"
                              >
                                Position
                                {{ pos1.position_name }}
                              </a>
                            </div>
                            <b-collapse
                              v-if="position2.length > 0"
                              :id="pos1.id"
                              :visible="position2.length > 0"
                              accordion="my-accordion-5"
                              role="tabpanel"
                            >
                              <ul
                                class="nav nav-sm flex-column accordion ml-4"
                                role="tablist"
                              >
                                <li
                                  class="nav-item"
                                  v-for="(pos2, idx) in position2"
                                  :key="idx"
                                >
                                  <div
                                    :class="`nav-link form-check form-check-inline`"
                                    v-if="pos2.position_name == undefined"
                                  >
                                    <input
                                      class="form-check-input"
                                      type="checkbox"
                                      v-model="pos2.isGranted"
                                      @change="
                                        changeBox(
                                          $event,
                                          company.id,
                                          company.company_name,
                                          pos2.id,
                                          pos2.department_name,
                                          'departement'
                                        )
                                      "
                                    />
                                    <a
                                      @click="
                                        getCompanyPosition(
                                          pos2.department_name,
                                          company.id,
                                          app_id.id,
                                          role_id.id,
                                          'pos3'
                                        )
                                      "
                                      style="padding-left: 0"
                                      tag="a"
                                      :class="`nav-link mx-3  text-black fw-lighter`"
                                      v-b-toggle="pos2.id"
                                      data-navtype="parent"
                                    >
                                      Departement
                                      {{ pos2.department_name }}
                                    </a>
                                  </div>
                                  <div
                                    v-else
                                    :class="`nav-link form-check form-check-inline`"
                                  >
                                    <input
                                      v-model="pos2.isGranted"
                                      class="form-check-input"
                                      type="checkbox"
                                      @change="
                                        changeBox(
                                          $event,
                                          company.id,
                                          company.company_name,
                                          pos2.id,
                                          pos2.position_name,
                                          'position'
                                        )
                                      "
                                    />

                                    <a
                                      style="padding-left: 0"
                                      tag="a"
                                      :class="`nav-link text-black mx-3 collapsed  fw-lighter`"
                                    >
                                      Position
                                      {{ pos2.position_name }}
                                    </a>
                                  </div>
                                  <b-collapse
                                    v-if="position3.length > 0"
                                    :id="pos2.id"
                                    :visible="position3.length > 0"
                                    accordion="my-accordion-6"
                                    role="tabpanel"
                                  >
                                    <ul
                                      class="nav nav-sm flex-column accordion ml-4"
                                      role="tablist"
                                    >
                                      <li
                                        class="nav-item"
                                        v-for="(pos3, idx) in position3"
                                        :key="idx"
                                      >
                                        <div
                                          :class="`nav-link form-check form-check-inline`"
                                          v-if="pos3.position_name == undefined"
                                        >
                                          <input
                                            v-model="pos3.isGranted"
                                            class="form-check-input"
                                            type="checkbox"
                                            @change="
                                              changeBox(
                                                $event,
                                                company.id,
                                                company.company_name,
                                                pos3.id,
                                                pos3.department_name,
                                                'departement'
                                              )
                                            "
                                          />
                                          <a
                                            @click="
                                              getCompanyPosition(
                                                pos3.department_name,
                                                company.id,
                                                app_id.id,
                                                role_id.id,
                                                'pos4'
                                              )
                                            "
                                            style="padding-left: 0"
                                            tag="a"
                                            :class="`nav-link mx-3  text-black fw-lighter`"
                                            v-b-toggle="pos3.id"
                                            data-navtype="parent"
                                          >
                                            Departement
                                            {{ pos3.department_name }}
                                          </a>
                                        </div>
                                        <div
                                          v-else
                                          :class="`nav-link form-check form-check-inline`"
                                        >
                                          <input
                                            v-model="pos3.isGranted"
                                            class="form-check-input"
                                            type="checkbox"
                                            @change="
                                              changeBox(
                                                $event,
                                                company.id,
                                                company.company_name,
                                                pos3.id,
                                                pos3.position_name,
                                                'position'
                                              )
                                            "
                                          />

                                          <a
                                            style="padding-left: 0"
                                            tag="a"
                                            :class="`nav-link text-black mx-3 collapsed  fw-lighter`"
                                          >
                                            Position
                                            {{ pos3.position_name }}
                                          </a>
                                        </div>
                                        <b-collapse
                                          v-if="position4.length > 0"
                                          :id="pos3.id"
                                          :visible="position4.length > 0"
                                          accordion="my-accordion-7"
                                          role="tabpanel"
                                        >
                                          <ul
                                            class="nav nav-sm flex-column accordion ml-4"
                                            role="tablist"
                                          >
                                            <li
                                              class="nav-item"
                                              v-for="(pos4, idx) in position4"
                                              :key="idx"
                                            >
                                              <div
                                                :class="`nav-link form-check form-check-inline`"
                                                v-if="
                                                  pos4.position_name ==
                                                  undefined
                                                "
                                              >
                                                <input
                                                  v-model="pos4.isGranted"
                                                  class="form-check-input"
                                                  type="checkbox"
                                                  @change="
                                                    changeBox(
                                                      $event,
                                                      company.id,
                                                      company.company_name,
                                                      pos4.id,
                                                      pos4.department_name,
                                                      'departement'
                                                    )
                                                  "
                                                />
                                                <a
                                                  @click="
                                                    getCompanyPosition(
                                                      pos4.department_name,
                                                      company.id,
                                                      app_id.id,
                                                      role_id.id,
                                                      'pos5'
                                                    )
                                                  "
                                                  style="padding-left: 0"
                                                  tag="a"
                                                  :class="`nav-link mx-3  text-black fw-lighter`"
                                                  v-b-toggle="pos4.id"
                                                  data-navtype="parent"
                                                >
                                                  Departement
                                                  {{ pos4.department_name }}
                                                </a>
                                              </div>
                                              <div
                                                v-else
                                                :class="`nav-link form-check form-check-inline`"
                                              >
                                                <input
                                                  v-model="pos4.isGranted"
                                                  class="form-check-input"
                                                  type="checkbox"
                                                  @change="
                                                    changeBox(
                                                      $event,
                                                      company.id,
                                                      company.company_name,
                                                      pos4.id,
                                                      pos4.position_name,
                                                      'position'
                                                    )
                                                  "
                                                />

                                                <a
                                                  style="padding-left: 0"
                                                  tag="a"
                                                  :class="`nav-link text-black mx-3 collapsed  fw-lighter`"
                                                >
                                                  Position
                                                  {{ pos4.position_name }}
                                                </a>
                                              </div>
                                              <b-collapse
                                                v-if="position5.length > 0"
                                                :id="pos4.id"
                                                :visible="position5.length > 0"
                                                accordion="my-accordion-7"
                                                role="tabpanel"
                                              >
                                                <ul
                                                  class="nav nav-sm flex-column accordion ml-4"
                                                  role="tablist"
                                                >
                                                  <li
                                                    class="nav-item"
                                                    v-for="(
                                                      pos5, idx
                                                    ) in position5"
                                                    :key="idx"
                                                  >
                                                    <div
                                                      :class="`nav-link form-check form-check-inline`"
                                                      v-if="
                                                        pos5.position_name ==
                                                        undefined
                                                      "
                                                    >
                                                      <input
                                                        v-model="pos5.isGranted"
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        @change="
                                                          changeBox(
                                                            $event,
                                                            company.id,
                                                            company.company_name,
                                                            pos5.id,
                                                            pos5.department_name,
                                                            'departement'
                                                          )
                                                        "
                                                      />
                                                      <a
                                                        @click="
                                                          getCompanyPosition(
                                                            pos5.department_name,
                                                            company.id,
                                                            app_id.id,
                                                            role_id.id,
                                                            'pos6'
                                                          )
                                                        "
                                                        style="padding-left: 0"
                                                        tag="a"
                                                        :class="`nav-link mx-3  text-black fw-lighter`"
                                                        v-b-toggle="pos5.id"
                                                        data-navtype="parent"
                                                      >
                                                        Departement
                                                        {{
                                                          pos5.department_name
                                                        }}
                                                      </a>
                                                    </div>
                                                    <div
                                                      v-else
                                                      :class="`nav-link form-check form-check-inline`"
                                                    >
                                                      <input
                                                        v-model="pos5.isGranted"
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        @change="
                                                          changeBox(
                                                            $event,
                                                            company.id,
                                                            company.company_name,
                                                            pos5.id,
                                                            pos5.position_name,
                                                            'position'
                                                          )
                                                        "
                                                      />

                                                      <a
                                                        style="padding-left: 0"
                                                        tag="a"
                                                        :class="`nav-link text-black mx-3 collapsed  fw-lighter`"
                                                      >
                                                        Position
                                                        {{ pos5.position_name }}
                                                      </a>
                                                    </div>
                                                  </li>
                                                </ul>
                                              </b-collapse>
                                            </li>
                                          </ul>
                                        </b-collapse>
                                      </li>
                                    </ul>
                                  </b-collapse>
                                </li>
                              </ul>
                            </b-collapse>
                          </li>
                        </ul>
                      </b-collapse>
                    </li>
                  </ul>
                </b-collapse>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-1"
      size="sm"
      hide-footer
      hide-header
      centered
      ok-disabled
      cancel-disabled
    >
      <div class="card-body text-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "RoleTemplate",
  computed: {
    listApp() {
      return this.$store.getters["role_template/listApp"];
    },
  },
  data() {
    return {
      app_id: "",
      role_id: "",
      company: "",
      listRoles: [],
      listCompany: [],
      listDepartement: [],
      position1: [],
      position2: [],
      position3: [],
      position4: [],
      position5: [],
      position6: [],
      position7: [],
      position8: [],
      position9: [],
      position10: [],
    };
  },

  mounted() {
    this.getApp();
  },
  methods: {
    getApp() {
      this.$store.dispatch("role_template/GET_LIST_APP");
    },

    getRoles(id) {
      let data = {
        app_id: id,
      };
      this.$store.dispatch("role_template/GET_LIST_ROLES", data).then(() => {
        const data = this.$store.getters["role_template/listRoles"];
        return (this.listRoles = data);
      });
    },

    getCompany(app_id, role_id) {
      let data = {
        app_id: app_id,
        role_id: role_id,
      };
      this.$store.dispatch("role_template/GET_LIST_COMPANY", data).then(() => {
        const data = this.$store.getters["role_template/listCompany"];
        return (this.listCompany = data);
      });
    },

    getCompanyDepartement(company_id, app_id, role_id) {
      this.$bvModal.show("modal-1");
      let data = {
        company_id: company_id,
        app_id: app_id,
        role_id: role_id,
      };
      this.$store
        .dispatch("role_template/GET_LIST_COMPANY_DEPARTEMENT", data)
        .then(() => {
          const data =
            this.$store.getters["role_template/listCompanyDepartment"];
          this.$bvModal.hide("modal-1");
          return (this.listDepartement = data);
        });
    },
    getCompanyPosition(department_name, company_id, app_id, role_id, action) {
      this.$bvModal.show("modal-1");
      let data = {
        company_id: company_id,
        app_id: app_id,
        role_id: role_id,
        parent: department_name,
      };
      this.$store
        .dispatch("role_template/GET_LIST_COMPANY_DEPARTEMENT", data)
        .then(() => {
          const data =
            this.$store.getters["role_template/listCompanyDepartment"];
          if (action == "pos1") {
            this.position1 = data;
          } else if (action == "pos2") {
            this.position2 = data;
          } else if (action == "pos3") {
            this.position3 = data;
          } else if (action == "pos4") {
            this.position4 = data;
          } else if (action == "pos5") {
            this.position5 = data;
          } else if (action == "pos6") {
            this.position6 = data;
          } else if (action == "pos7") {
            this.position7 = data;
          } else if (action == "pos8") {
            this.position8 = data;
          } else if (action == "pos9") {
            this.position9 = data;
          } else if (action == "pos10") {
            this.position10 = data;
          }
          this.$bvModal.hide("modal-1");
        });
    },

    changeCompany(event, company_id, company_name) {
      let data = {
        company_id: company_id,
        company_name: company_name,
        orgunitpos_id: "*",
        client_id: this.app_id.id,
        client_name: this.app_id.name,
        role_id: this.role_id.id,
        role_name: this.role_id.name,
        isGranted: event.target.checked,
      };
      // return console.log(data);
      try {
        this.$store.dispatch("role_template/CREATE_DATA", data).then((resp) => {
          this.$swal("Saved", "Your checked has been saved", "success").then(
            () => {
              // this.app_id = "";
              // this.role_id = "";
            }
          );
        });
      } catch (error) {
        this.$swal("Error", "Error while add data", "error");
      }
    },

    changeBox(event, company_id, company_name, id, orgunitpos_name, action) {
      let data = {
        company_id: company_id,
        company_name: company_name,
        orgunitpos_id: id,
        orgunitpos_type: action == "departement" ? "O" : "S",
        orgunitpos_name: orgunitpos_name,
        client_id: this.app_id.id,
        client_name: this.app_id.name,
        role_id: this.role_id.id,
        role_name: this.role_id.name,
        isGranted: event.target.checked,
      };

      // return console.log(data);
      try {
        this.$store.dispatch("role_template/CREATE_DATA", data).then((resp) => {
          this.$swal("Saved", "Your checked has been saved", "success").then(
            () => {
              // this.app_id = "";
              // this.role_id = "";
            }
          );
        });
      } catch (error) {
        this.$swal("Error", "Error while add data", "error");
      }
    },
  },
};
</script>
